var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-selects-wpr"
  }, [_c('i', {
    staticClass: "el-icon-error remove-btn",
    attrs: {
      "title": "清空"
    },
    on: {
      "click": _vm.clearInput
    }
  }), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('el-select', {
    ref: "select",
    staticClass: "user-selects",
    attrs: {
      "size": "medium",
      "multiple": _vm.multiple,
      "filterable": "",
      "remote": "",
      "popper-class": "user-selects-list",
      "disabled": _vm.disabled,
      "placeholder": _vm.holder,
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.change
    },
    model: {
      value: (_vm.selectValue),
      callback: function($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.lastName,
        "value": item.id
      }
    }, [_c('span', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(_vm.leftFormater(item)))]), _vm._v(" "), _c('span', {
      staticClass: "user-dept"
    }, [_vm._v(_vm._s(_vm.rightFormater(item)))])])
  }), 1)], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3717537c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userSelect/searchDownList.vue
// module id = null
// module chunks = 